// Rendered inside an area route when the signed-in employee lacks that area's
// grant — either because /api/admin/permissions/me didn't list it (proactive
// gate) or because an area-scoped endpoint answered 403 (safety net). Never a
// crash: the employee stays in the shell and can navigate to areas they do have.
import { Link } from "@tanstack/react-router";

import type { AreaMeta } from "../lib/areas";
import { LockIcon } from "./icons";

export function AccessRequired({ area }: { area?: AreaMeta }) {
  return (
    <div className="ad-access">
      <div className="ad-access__card">
        <span className="ad-state__icon" aria-hidden="true">
          <LockIcon />
        </span>
        <h2 className="ad-access__title">Access required</h2>
        <p className="ad-access__body">
          {area ? (
            <>
              You don't have access to <strong>{area.label}</strong> yet.
            </>
          ) : (
            <>You don't have access to this area yet.</>
          )}{" "}
          Ask an admin with System Admin access to grant it to you.
        </p>
        <Link to="/" className="ad-btn-link">
          Back to home
        </Link>
      </div>
    </div>
  );
}
